import { checkedTypes } from "constants/types";
import { isExcel } from "utils";
import { getDocItemsArrayList } from "layout/dictionarySearch/content/ContentPanel";

export const isEmptyDocument = (doc) => {
  if (
    isExcel(doc.name) &&
    doc.occurrences === 0 &&
    doc.paragraphCount !== undefined &&
    doc.paragraphCount === 0
  ) {
    return true;
  }
  return (
    !isExcel(doc.name) &&
    doc.wordCount !== undefined &&
    doc.wordCount === 0 &&
    doc.occurrences === 0
  );
};

export const getFolderByFolderDocList = (folder) => {
  const {
    dictionary: { categories },
    documents,
  } = folder;
  const checkedDocs = documents?.filter(
    (d) => d.checkState === checkedTypes.CHECKED
  );
  const checkedItems = categories
    ?.map((c) => c.items?.filter((i) => i.checkState === checkedTypes.CHECKED))
    .flat(1)
    .map((i) => i?.id);
  let docList;
  if (checkedDocs.length && checkedItems.length) {
    docList = checkedDocs.map((d) => ({
      docName: d.name,
      selectedTerms: checkedItems,
    }));
  } else if (checkedDocs.length && !checkedItems.length) {
    const allItems = categories
      ?.map((c) => c.items.filter((i) => i.occurrences))
      .flat(1)
      .map((i) => i.id);
    docList = checkedDocs.map((d) => ({
      docName: d.name,
      selectedTerms: allItems,
    }));
  } else {
    docList = [];
  }
  return docList;
};

export const getDocList = (documents) => {
  let docList;
  docList = getDocItemsArrayList(documents);
  if (docList.length) {
    return docList;
  }
  docList = documents.map((d) => ({
    docName: d.name,
    selectedTerms: [],
  }));
  if (docList.length) {
    return docList;
  }
  return [];
};

export const getDropdownTitle = (name, description) => {
  let title = `${name}.`;

  if (description) {
    title += `\n${description}`;
  }

  return title;
};

// Sets horizontal scrollbar placeholder for categories pane if documents pane has horizontal scrollbar
export const setScrollbarPlaceholderForCategories = (
  categoriesRef,
  documentsRef
) => {
  const hasHorizontalScrollbar = (element) => {
    const { scrollWidth, clientWidth } = element;
    return scrollWidth > clientWidth;
  };

  const categories = categoriesRef?.current?.props.outerRef.current;
  const documents = documentsRef?.current?.props.outerRef.current;
  const placeholderClass = "scrollbar_placeholder";

  if (!categories || !documents) return;

  if (hasHorizontalScrollbar(documents)) {
    categories.classList.add(placeholderClass);
  } else {
    categories.classList.remove(placeholderClass);
  }
};
